<template>
    <div class="app-container">
        <div class="common-section-bg search-div">
            <el-form :inline="true" size="mini" class="search-form">
                <el-form-item label="小区">
                    <el-select
                        v-model="queryParam.commId"
                        clearable
                        filterable
                        placeholder="请选择小区"
                        style="width: 180px"
                        @change="handleCommChange"
                    >
                        <el-option
                            v-for="item in commOptions"
                            :key="item.commId"
                            :label="item.commName"
                            :value="item.commId"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="房号">
                    <el-select
                        v-model="queryParam.resourceId"
                        clearable
                        filterable
                        placeholder="请选择房号"
                        style="width: 180px"
                    >
                        <el-option
                            v-for="item in roomOptions"
                            :key="item.resourceId"
                            :label="item.resourceName"
                            :value="item.resourceId"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input
                        v-model="queryParam.phone"
                        clearable
                        placeholder="请输入手机号"
                        style="width: 180px"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        style="background: #1890ff; border-color: #1890ff"
                        icon="el-icon-search"
                        :loading="memberLoading"
                        @click="getRecordList()"
                    >
                        查询
                    </el-button>
                    <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button
                        icon="el-icon-download"
                        :loading="exportLoading"
                        @click="handleExport"
                    >
                        导出
                    </el-button>
                    <el-button
                        type="primary"
                        style="background: #1067e0; border-color: #1067e0"
                        icon="el-icon-edit"
                        @click="openAssignDrawer"
                    >
                        积分发放
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--外侧table-->
        <div class="common-section-bg common-section-body">
            <div class="section-title">会员积分发放记录</div>
            <el-table
                v-loading="recordLoading"
                :data="recordTableData"
                size="mini"
                style="width: 100%; min-height: 300px"
            >
                <el-table-column prop="id" label="ID" width="80" />
                <el-table-column prop="commId" label="小区" width="90" >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.community.commName }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="resourceId" label="住房" width="90" >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.resourceName ? scope.row.resourceName : "--" }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="用户名" width="100" >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.user.name }}
                        </span>
                        </template>
                    </el-table-column>
                <el-table-column prop="phone" label="手机号" width="100" />
                <el-table-column prop="points" label="积分数" width="90" />
                <el-table-column prop="type" label="类型" width="100" >
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.type === '增加' ? 'success' : 'danger'">
                            {{ scope.row.type }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="时间" width="180" />
                <el-table-column prop="source" label="积分类型" min-width="180" show-overflow-tooltip />
                <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
                <el-table-column prop="admin_id" label="操作人" width="80" >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.admin!=null?scope.row.admin.name:"自动发放" }}
                        </span>
                    </template>
                </el-table-column>

            </el-table>
            <pagination
                v-show="recordTotal"
                :total="recordTotal"
                :page.sync="recordQuery.page"
                :limit.sync="recordQuery.size"
                @pagination="getRecordList"
            />
        </div>

        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showAssignDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="900px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">积分发放</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="showAssignDrawer = false" />
                </div>
            </template>
            <div class="custom-content">
                <div class="common-section-bg search-div assign-search-box">
                    <el-form ref="assignSearchForm" :model="assignQueryParam" :rules="assignSearchRules" :inline="true" size="mini" class="search-form">
                        <el-form-item label="小区" prop="commId">
                            <el-select
                                v-model="assignQueryParam.commId"
                                clearable
                                filterable
                                placeholder="请选择小区"
                                style="width: 140px"
                                @change="handleAssignCommChange"
                            >
                                <el-option
                                    v-for="item in commOptions"
                                    :key="item.commId"
                                    :label="item.commName"
                                    :value="item.commId"
                                />
                            </el-select>
                        </el-form-item>
                        <!--房号选择后自动带出用户手机号-->
                        <el-form-item label="房号">
                            <el-select
                                v-model="assignQueryParam.resourceId"
                                clearable
                                filterable
                                placeholder="请选择房号"
                                style="width: 140px"
                                @change="handleAssignRoomChange"
                            >
                                <el-option
                                    v-for="item in assignRoomOptions"
                                    :key="item.resourceId"
                                    :label="item.resourceName"
                                    :value="item.resourceId"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="手机号" prop="phone">
                            <el-input
                                v-model="assignQueryParam.phone"
                                clearable
                                placeholder="请输入手机号"
                                style="width: 140px"
                            />
                        </el-form-item>
                        <el-form-item class="assign-action-item">
                            <el-button
                                type="primary"
                                style="background: #1890ff; border-color: #1890ff"
                                icon="el-icon-search"
                                :loading="assignMemberLoading"
                                @click="searchAssignMember"
                            >
                                查询会员
                            </el-button>
                            <el-button icon="el-icon-refresh" @click="resetAssignQuery">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="common-section-bg common-section-body member-card">
                    <div class="section-title">会员信息及积分分配</div>
                    <div v-if="assignMemberInfo" class="member-info-wrap">
                        <div class="member-info-grid">
                            <div class="info-item">姓名：{{ assignMemberInfo.nickname || assignMemberInfo.name || "--" }}</div>
                            <div class="info-item">手机号：{{ assignMemberInfo.phone || "--" }}</div>
                            <div class="info-item">总积分：{{ assignMemberScore.totalScore || 0 }}</div>
                            <div class="info-item">物业积分：{{ assignMemberScore.wuyejifen || 0 }}</div>
                            <div class="info-item">食堂积分：{{ assignMemberScore.yinbaojifen || 0 }}</div>
                            <div class="info-item">商城积分：{{ assignMemberScore.youzanjifen || 0 }}</div>
                        </div>
                        <el-divider />
                        <div class="assign-row">
                            <el-select
                                v-model="assignScoreForm.source"
                                size="mini"
                                style="width: 140px"
                                placeholder="积分类型"
                            >
                                <el-option v-for="item in scoreTypeList" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                            <el-input-number
                                v-model="assignScoreForm.points"
                                size="mini"
                                :min="-9999999"
                                :max="9999999"
                                label="积分数量"
                            />
                        </div>
                        <div class="assign-remark-row">
                            <el-input
                                v-model="assignScoreForm.remark"
                                type="textarea"
                                :rows="3"
                                placeholder="请输入备注"
                            />
                        </div>
                        <div class="assign-submit-row">
                            <el-tag type="success">正数增加，负数减少</el-tag>
                            <el-button
                                type="primary"
                                :loading="assignLoading"
                                style="margin-left: auto; background: #1067e0; border-color: #1067e0"
                                @click="submitScore"
                            >提交分配</el-button>
                        </div>
                    </div>
                    <el-empty v-else description="请先在抽屉中查询会员" :image-size="80" />
                </div>

                <div class="common-section-bg common-section-body drawer-record-card">
                    <div class="section-title">当前会员积分变动记录</div>
                    <el-table
                        v-if="assignMemberInfo"
                        v-loading="assignRecordLoading"
                        :data="assignRecordTableData"
                        size="mini"
                        style="width: 100%; min-height: 220px"
                    >
                        <el-table-column prop="id" label="ID" width="80" />
                <el-table-column prop="commId" label="小区" width="90" >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.community.commName }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="resourceId" label="住房" width="90" >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.resourceName ? scope.row.resourceName : "--" }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="用户名" width="100" >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.user.name }}
                        </span>
                        </template>
                    </el-table-column>
                <el-table-column prop="phone" label="手机号" width="100" />
                <el-table-column prop="points" label="积分数" width="90" />
                <el-table-column prop="type" label="类型" width="100" >
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.type === '增加' ? 'success' : 'danger'">
                            {{ scope.row.type }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="时间" width="180" />
                <el-table-column prop="source" label="积分类型" min-width="180" show-overflow-tooltip />
                <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
                <el-table-column prop="admin_id" label="操作人" width="80" >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.admin.name }}
                        </span>
                    </template>
                </el-table-column>
                    </el-table>
                    <pagination
                        v-if="assignMemberInfo"
                        v-show="assignRecordTotal"
                        :total="assignRecordTotal"
                        :page.sync="assignRecordQuery.page"
                        :limit.sync="assignRecordQuery.size"
                        @pagination="getAssignRecordList"
                    />
                    <el-empty v-else description="请先在抽屉中查询会员" :image-size="80" />
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import memberApi from "@/api/tianzheng/member";
import Qu from "@/api/tianzheng/Qu";
import Pagination from "@/components/Pagination";
import jifen from "@/api/tianzheng/jifen";

export default {
    name: "JifenFenpei",
    components: {
        Pagination,
    },
    data() {
        return {
            commOptions: [],
            roomOptions: [],
            queryParam: {
                commId: "",
                resourceId: "",
                phone: "",
            },
            memberLoading: false,
            showAssignDrawer: false,
            assignLoading: false,
            assignRoomOptions: [],
            assignQueryParam: {
                commId: "",
                resourceId: "",
                phone: "",
            },
            assignSearchRules: {
                commId: [{ required: true, message: "请选择小区", trigger: "change" }],
                phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
            },
            assignMemberLoading: false,
            assignMemberInfo: null,
            assignMemberScore: {
                totalScore: 0,
                wuyejifen: 0,
                yinbaojifen: 0,
                youzanjifen: 0,
            },
            assignRecordLoading: false,
            assignRecordTableData: [],
            assignRecordTotal: 0,
            assignRecordQuery: {
                page: 1,
                size: 10,
            },
            assignScoreForm: {
                points: 0,
                source: "物业",
                remark: "",
            },
            scoreTypeList: [
                { value: "物业", label: "物业" },
                { value: "食堂", label: "食堂" },
                { value: "商城", label: "商城" },
            ],
            recordLoading: false,
            exportLoading: false,
            recordTableData: [],
            recordTotal: 0,
            recordQuery: {
                page: 1,
                size: 10,
            },
        };
    },
    mounted() {
        this.getCommOptions();
        this.getRecordList();
    },
    methods: {
        getCommOptions() {
            Qu.select({}).then((res) => {
                if (res.code == 200) {
                    this.commOptions = res.result || [];
                }
            });
        },
        handleCommChange(val) {
            this.queryParam.resourceId = "";
            this.roomOptions = [];
            if (!val) return;
            Qu.listTwo({ commId: val, page: 1, size: 10000 }).then((res) => {
                this.roomOptions = (res.result && res.result.list2) || [];
            });
        },
        resetSearch() {
            this.queryParam = {
                commId: "",
                resourceId: "",
                phone: "",
            };
            this.roomOptions = [];
            this.recordQuery = { page: 1, size: 10 };
            this.getRecordList();
        },
        openAssignDrawer() {
            this.showAssignDrawer = true;
            this.resetAssignQuery();
        },
        handleAssignCommChange(val) {
            this.assignQueryParam.resourceId = "";
            this.assignQueryParam.phone = "";
            this.assignRoomOptions = [];
            if (!val) return;
            Qu.listTwo({ commId: val, page: 1, size: 10000 }).then((res) => {
                this.assignRoomOptions = (res.result && res.result.list2) || [];
            });
        },
        handleAssignRoomChange(val) {
            this.assignQueryParam.phone = "";
            if (!val || !this.assignQueryParam.commId) return;
            Qu.findUser({
                commId: this.assignQueryParam.commId,
                resourceId: val,
            }).then((res) => {
                if (res.code == 200 && res.result) {
                    this.assignQueryParam.phone = res.result.phone || "";
                }
            });
        },
        resetAssignQuery() {
            this.assignQueryParam = {
                commId: "",
                resourceId: "",
                phone: "",
            };
            this.assignRoomOptions = [];
            this.assignMemberInfo = null;
            this.assignMemberScore = {
                totalScore: 0,
                wuyejifen: 0,
                yinbaojifen: 0,
                youzanjifen: 0,
            };
            this.assignRecordTableData = [];
            this.assignRecordTotal = 0;
            this.assignRecordQuery = {
                page: 1,
                size: 10,
            };
            this.assignScoreForm = { points: 0, source: "物业", remark: "" };
            if (this.$refs.assignSearchForm) {
                this.$refs.assignSearchForm.clearValidate();
            }
        },
        searchMember() {
            this.recordQuery.page = 1;
            jifen.jifenfafanglogdetail(this.assignQueryParam).then((res) => {
                if (res.code == 200 && res.result) {
                    const data = res.result;
                    this.assignMemberInfo = {
                        id: data.id,
                        nickname: data.name || data.nickname,
                        phone: data.phone,
                    };
                    this.assignMemberScore = {
                        totalScore: data.totalScore || 0,
                        wuyejifen: data.wuyejifen || 0,
                        yinbaojifen: data.yinbaojifen || 0,
                        youzanjifen: data.youzanjifen || 0,
                    };
                } else {    
                    this.assignMemberInfo = null;
                    this.$message.warning("未查询到会员信息");
                }
            });
        },
        searchAssignMember() {
            this.$refs.assignSearchForm.validate((valid) => {
                if (!valid) return;
                this.assignMemberLoading = true;
                memberApi.list({ ...this.assignQueryParam, page: 1, size: 1 }).then((res) => {
                    const list = (res.result && res.result.list) || [];
                    if (!list.length) {
                        this.assignMemberInfo = null;
                        this.assignRecordTableData = [];
                        this.assignRecordTotal = 0;
                        this.$message.warning("未查询到会员信息");
                        return;
                    }
                    this.assignMemberInfo = list[0];
                    this.loadAssignMemberScore();
                    this.assignRecordQuery.page = 1;
                    this.getAssignRecordList();
                }).finally(() => {
                    this.assignMemberLoading = false;
                });
            });
        },
        loadAssignMemberScore() {
            if (!this.assignMemberInfo || !this.assignMemberInfo.id) return;
            memberApi.detail({ id: this.assignMemberInfo.id }).then((res) => {
                if (res.code == 200 && res.result) {
                    const data = res.result;
                    this.assignMemberScore = {
                        totalScore: data.totalScore || 0,
                        wuyejifen: data.wuyejifen || 0,
                        yinbaojifen: data.yinbaojifen || 0,
                        youzanjifen: data.youzanjifen || 0,
                    };
                }
            });
        },
        getAssignRecordList() {
            if (!this.assignMemberInfo || !this.assignMemberInfo.phone) {
                this.assignRecordTableData = [];
                this.assignRecordTotal = 0;
                return;
            }
            this.assignRecordLoading = true;
            jifen.jifenfafangloglist({
                phone: this.assignMemberInfo.phone,
                page: this.assignRecordQuery.page,
                size: this.assignRecordQuery.size,
            }).then((res) => {
                this.assignRecordTableData = (res.result && res.result.list) || [];
                this.assignRecordTotal = (res.result && res.result.total) || 0;
            }).finally(() => {
                this.assignRecordLoading = false;
            });
        },
        submitScore() {
            if (!this.assignMemberInfo || !this.assignMemberInfo.id) {
                this.$message.warning("请先查询并选择会员");
                return;
            }
            
            if (!this.assignScoreForm.points) {
                this.$message.warning("请输入积分数量");
                return;
            }
            this.assignLoading = true;
            jifen.jifenfafanglogcreate({
                id: this.assignMemberInfo.id,
                phone: this.assignMemberInfo.phone,
                commId: this.assignQueryParam.commId,
                resourceId: this.assignQueryParam.resourceId,
                points: this.assignScoreForm.points,
                source: this.assignScoreForm.source,
                remark: this.assignScoreForm.remark,
            }).then((res) => {
                if (res.code == 200) {
                    this.$message.success("积分分配成功");
                    this.assignScoreForm.points = 0;
                    this.assignScoreForm.remark = "";
                    this.loadAssignMemberScore();
                    this.assignRecordQuery.page = 1;
                    this.getAssignRecordList();
                    this.recordQuery.page = 1;
                    this.getRecordList();
                } else {
                    this.$message.error(res.message || "积分分配失败");
                }
            }).finally(() => {
                this.assignLoading = false;
            });
        },
        getRecordList() {
            this.recordLoading = true;
            const params = {
                ...this.queryParam,
                ...this.recordQuery,
            };
            jifen.jifenfafangloglist(params).then((res) => {
                this.recordTableData = (res.result && res.result.list) || [];
                this.recordTotal = (res.result && res.result.total) || 0;
            }).finally(() => {
                this.recordLoading = false;
            });
        },
        handleExport() {
            this.exportLoading = true;
            jifen.jifenfafanglogexport({ ...this.queryParam }).then((res) => {
                if (res.code === 200 && res.result && res.result.url) {
                    window.open(res.result.url, "_blank");
                    this.$message.success("导出成功");
                } else {
                    this.$message.error(res.message || "导出失败");
                }
            }).finally(() => {
                this.exportLoading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}

.search-div {
    margin-bottom: 16px;
    padding: 16px;
}

.member-card {
    margin-bottom: 16px;
}

.drawer-record-card {
    margin-bottom: 16px;
}

.section-title {
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.member-info-wrap {
    padding: 8px 4px;
}

.member-info-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(180px, 1fr));
    gap: 10px 16px;
}

.info-item {
    color: #606266;
}

.assign-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.assign-remark-row {
    margin-top: 12px;
}

.assign-submit-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
}

.assign-search-box {
    margin-bottom: 12px;
}

.assign-search-box .search-form {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

.assign-search-box .search-form .el-form-item {
    margin-bottom: 0;
}

.assign-action-item {
    margin-left: auto;
    margin-right: 0;
    white-space: nowrap;
}

@media (max-width: 768px) {
    .member-info-grid {
        grid-template-columns: 1fr;
    }
}
</style>
